import * as React from "react";
import { ReactElement } from "react";
import {
  FullDescriptionData,
  isPlayingDescriptionType,
  TrainingCenterBundleItemFullDescription,
} from "../../../system/AppState/AppStateTrainingCenter";
import { List } from "../../../utils/List";
import {
  lookupTranslationRequired,
  TrainingCenterLanguagePreference,
} from "../TrainingCenterLanguageLookup";
import FullDescription from "./FullDescription/FullDescription";
import ReadTextButton from "./FullDescription/ReadTextButton";

export interface TrainingCenterBundleItemFullDescriptionListProps {
  languagePreference: TrainingCenterLanguagePreference;
  fullDescriptions: List<TrainingCenterBundleItemFullDescription>;
  hasSpeechMarks: boolean;
  isPlaying: isPlayingDescriptionType;
  onPlayAudioClick: () => void;
  onAudioEnded: (
    currentPlayingItem: TrainingCenterBundleItemFullDescription,
    currentDescription: FullDescriptionData
  ) => void;
  getText: (
    type: isPlayingDescriptionType,
    sentence: string | JSX.Element[] | undefined,
    currentPlayingItem: TrainingCenterBundleItemFullDescription,
    currentDecsription: FullDescriptionData
  ) => JSX.Element[];
}

const TrainingCenterBundleItemFullDescriptionList = React.memo(
  React.forwardRef(function TrainingCenterTestQuestionsList(
    props: TrainingCenterBundleItemFullDescriptionListProps,
    currentAudioRef: React.Ref<HTMLAudioElement>
  ): ReactElement {
    return (
      <div className="TrainingCenterBundleItemFullDescriptionList">
        <ReadTextButton
          isPlaying={props.isPlaying !== false}
          show={props.hasSpeechMarks}
          onClick={props.onPlayAudioClick}
        />
        {props.fullDescriptions.map((fullDescriptionRow) => {
          const displayData = lookupTranslationRequired(
            props.languagePreference,
            fullDescriptionRow.fullDescriptionData,
            (x) => x
          );

          return (
            <FullDescription
              key={fullDescriptionRow.itemId.toString()}
              title={props.getText("title", displayData.title, fullDescriptionRow, displayData)}
              subtitle={props.getText(
                "subtitle",
                displayData.subtitle,
                fullDescriptionRow,
                displayData
              )}
              text={props.getText("text", displayData.text, fullDescriptionRow, displayData)}
              imageUrl={displayData.imageUrl}
              imageDescription={displayData.imageDescription}
              speechFiles={displayData.speechFiles}
              isPlaying={fullDescriptionRow.isPlaying}
              ref={currentAudioRef}
              onAudioEnded={() => props.onAudioEnded(fullDescriptionRow, displayData)}
            />
          );
        })}
      </div>
    );
  })
);

export default TrainingCenterBundleItemFullDescriptionList;
